__turbopack_context__.v({
  "draggable": "ImageUploadPreview-module__5O90_a__draggable",
  "draggableIcon": "ImageUploadPreview-module__5O90_a__draggableIcon",
  "error": "ImageUploadPreview-module__5O90_a__error",
  "image": "ImageUploadPreview-module__5O90_a__image",
  "root": "ImageUploadPreview-module__5O90_a__root",
});
